export default {
	urlApis(state){ return state.urlApis; },
	langProjects(state){ return state.langProjects; },
	accessApp(state){ return state.access; },
	get_asideStorage(state){ return state.asideStorage;},
	lateral(state) { return state.lateralShow; },
}
